import PropTypes from "prop-types";

const propTypes = {
  maxChars: PropTypes.number,
  parentId: PropTypes.number,
  closeRootModal: PropTypes.func,
  confirmClose: PropTypes.bool,
  handleCloseButtonClick: PropTypes.func,
};

export default propTypes;
